import { connect } from 'react-redux'
import EulaPrompt from './component'
import {
    // Actions
    acceptEula,
    declineEula,

    // Selectors
    getEula,
    getAcceptText,
    getDeclineText,
} from '../../../data'

function mapStateToProps(state) {
    return {
        eula: getEula(state),
        acceptText: getAcceptText(state),
        declineText: getDeclineText(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        accept: () => {
            dispatch(acceptEula())
        },
        decline: () => {
            dispatch(declineEula())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EulaPrompt)



// WEBPACK FOOTER //
// ./src/features/Eula/components/Eula/Prompt/index.js